import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Privacy.css';

// Volledige algemene voorwaarden specifiek voor schoonmakers - bewust kort
// gehouden: de concrete afspraken over de samenwerking (vergoeding,
// uitbetaling, planning, beeindiging) staan al in het individuele
// schriftelijke contract per schoonmaker, dit document dekt enkel het
// gebruik van het platform zelf. Zie Terms.js voor de keuzepagina.
function TermsSchoonmaker() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isNative = localStorage.getItem('isNativeApp') === 'true';

  useEffect(() => {
    document.title = 'SmartStays - Algemene voorwaarden schoonmakers';
  }, []);

  const sections = [1, 2, 3, 4, 5, 6, 7, 8];

  return (
    <div className="privacy-container">
      <Navbar />
      {isNative && (
        <div className="legal-native-bar">
          <button type="button" className="native-detail-back" onClick={() => navigate(-1)} aria-label={t('common.back')}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 6l-6 6 6 6" /></svg>
          </button>
        </div>
      )}

      <div className="privacy-content">
        <h1>{t('termsSchoonmaker.title')}</h1>
        <p className="privacy-updated">{t('termsSchoonmaker.updated')}</p>
        <p className="privacy-intro">{t('termsSchoonmaker.intro')}</p>

        {sections.map((n) => (
          <section className="privacy-section" key={n}>
            <h2>{t(`termsSchoonmaker.section${n}Title`)}</h2>
            <p>{t(`termsSchoonmaker.section${n}Text`)}</p>
          </section>
        ))}

        <section className="privacy-section">
          <h2>{t('termsSchoonmaker.contactTitle')}</h2>
          <p>
            {t('termsSchoonmaker.contactText')}{' '}
            <a href="mailto:info@smartstays.be">info@smartstays.be</a>
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default TermsSchoonmaker;
